<template>
  <div class="partner bg-white text-default padding--top-4 padding--bottom-4">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <h4 v-if="title" class="text-uppercase margin--bottom-2">{{ title }}</h4>
          <h4 v-if="!title && isDtm && !isEsports" class="text-uppercase margin--bottom-2">{{ $t('partner.title') }}</h4>
          <h4 v-if="!title && isDtmTrophy && !isEsports" class="text-uppercase margin--bottom-2">{{ $t('partnerTrophy.title') }}</h4>
          <h4 v-if="!title && isEsports" class="text-uppercase margin--bottom-2">{{ $t('partnerEsport.title') }}</h4>
        </div>
      </div>
      <div class="row" :class="{ 'justify-content-between': premiumPartners.length > 2, 'justify-content-left': premiumPartners.length <= 2 }">
        <div v-for="(partner, index) in premiumPartners" :key="index" class="col-auto">
          <a :href="partner.link && partner.link.url ? partner.link.url : '#'" target="_blank" :title="partner.link ? partner.link.title : ''">
            <img
              class="partner__image"
              :alt="partner.link ? partner.link.title : ''"
              :width="partner.logo.width"
              :height="partner.logo.height"
              :src="partner.logo.url"/>
          </a>
        </div>
      </div>
      <div v-if="secondLevelPartners.length > 0" class="col-12 partner__hr"></div>
      <div class="row">
        <div v-for="(partner, index) in secondLevelPartners" :key="index" class="col-auto partner__second-level">
          <a :href="partner.link && partner.link.url ? partner.link.url : '#'" target="_blank" :title="partner.link ? partner.link.title : ''">
            <img
              class="partner__image"
              :alt="partner.link ? partner.link.title : ''"
              :width="partner.logo.width"
              :height="partner.logo.height"
              :src="partner.logo.url"/>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppConst from '../config/app.const';
import Settings from '../config/settings';

export default {
  name: 'Partner',
  props: {
    name: {
      type: String,
      required: false,
      default: null
    },
    title: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      partners: []
    };
  },
  computed: {
    premiumPartners: function () {
      return this.partners.filter(partner => {
        return partner.premiumPartner;
      });
    },
    secondLevelPartners: function () {
      return this.partners.filter(partner => {
        return !partner.premiumPartner;
      });
    },
    queryName: function () {
      if (this.name) {
        return this.name;
      }
      return this.$store.getters['page/raceSeriesPartner'];
    },
    raceSeries: function () {
      return this.$store.getters['page/raceSeries'];
    },
    isDtm: function () {
      return this.$store.getters['page/raceSeries'] === AppConst.DTM;
    },
    isDtmTrophy: function () {
      return this.$store.getters['page/raceSeries'] === AppConst.DTM_TROPHY;
    },
    isEsports: function () {
      return this.$store.getters['page/isEsport'];
    }
  },
  methods: {
    async fetchPartners () {
      await this.$store.dispatch(AppConst.FETCH_PATH_NAME, {
        path: `data?query=${this.queryName}`,
        lifetime: Settings.LIFETIME_DEFAULT
      })
        .then(response => {
          let partners = [];
          if (response.partners) {
            partners = response.partners;
          }
          if (response.partnerTrophies) {
            partners = response.partnerTrophies;
          }
          if (response.partnerEsportses) {
            partners = response.partnerEsportses;
          }
          if (response.partnerDtmSuppliers) {
            partners = response.partnerDtmSuppliers;
          }
          this.partners = partners;
        });
    }
  },
  watch: {
    $route () {
      this.fetchPartners();
    }
  },
  created () {
    this.fetchPartners();
  }
};
</script>

<style lang="scss" scoped>
  .partner {
    &__image {
      width: 115px;
      height: 75px;
      max-width: 100%;
    }

    &__hr {
      margin-top: 1.5rem;
      margin-bottom: 1.5rem;
      border: 0;
      border-top: 1px solid $color-bg;
      opacity: 0.8;
    }

    &__second-level {
      transform: scale(0.75);
    }
  }
</style>
